import React from "react";
import {
    VendorChevronRightSvg,
    VendorFileSvg,
    VendorFolderSvg,
} from "../../../components/CommonSvg";

const DocumentFolderList = ({ categories, counts, totalFiles, onOpen }) => (
    <div className="doc-folders">
        <button type="button" className="doc-folder all" onClick={() => onOpen("")}>
            <span className="doc-type-tag folder all">
                <VendorFileSvg size={18} />
            </span>
            <span className="doc-fmeta">
                <b>All Documents</b>
                <i>
                    {totalFiles === 1 ? "1 document" : `${totalFiles} documents`}
                </i>
            </span>
            <span className="doc-fgo">
                <VendorChevronRightSvg />
            </span>
        </button>

        {categories.map((folder) => {
            const files = Number(counts[folder.id] || 0);
            return (
                <button
                    type="button"
                    key={folder.id}
                    className="doc-folder"
                    onClick={() => onOpen(folder.id)}
                >
                    <span className="doc-type-tag folder">
                        <VendorFolderSvg size={18} />
                    </span>
                    <span className="doc-fmeta">
                        <b>{folder.name}</b>
                        <i>{files === 1 ? "1 document" : `${files} documents`}</i>
                    </span>
                    <span className="doc-fgo">
                        <VendorChevronRightSvg />
                    </span>
                </button>
            );
        })}
    </div>
);

export default DocumentFolderList;
